import { render } from "./ProductCreate.vue?vue&type=template&id=2579f6d2&ts=true"
import script from "./ProductCreate.vue?vue&type=script&lang=ts"
export * from "./ProductCreate.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__